import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import DropdownButton from 'components/ui/tailwind/DropdownButton';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import EditReferenceNumbersModal from 'components/modules/shipments/EditReferenceNumbersModal';
import { Checkbox, Label } from '@cargomatic/ui';
import DeleteButton from 'components/v2/buttons/DeleteButton';
import IconTextDisplay from 'components/v2/IconTextDisplay';
import CalendarIcon from 'components/v2/icons/CalendarIcon';
import TruckIcon from 'components/v2/icons/TruckIcon';
import stopIntents from 'config/stop-intent-types';
import SessionStore from 'stores/SessionStore';
import { titleize } from 'underscore.string';
import Location from './Location';
import LoadDistributionModal from './LoadDistributionModal';
import StopAppointmentWindowModal from './StopAppointmentWindowModal';
import { getLoadQuantity, getLoadWeight, getLoadDimensions, } from '../../../load/Loads';
const dateTimeFormat = 'L LT';
function formatDate(date, timezone, t) {
    if (!date) {
        return t('NOT_SET');
    }
    return moment(date).tz(timezone).format(dateTimeFormat);
}
class Stop extends Component {
    constructor(props) {
        super(props);
        this.handleStopFieldChange = (field, value) => {
            this.props.onStopFieldChange(this.props.stop, field, value);
        };
        this.handleRequireAppointmentFieldChange = (field, value) => {
            this.props.onStopFieldChange(this.props.stop, field, value);
            /**
             * Why this?
             * If user selects requires appointment,
             * reset the start and end window to null
             */
            if (value) {
                this.props.onEndChange(this.props.stop, null);
                this.props.onStartChange(this.props.stop, null);
            }
        };
        this.handleLocationFieldChange = (field, value) => {
            this.props.onLocationFieldChange(this.props.stop, field, value);
        };
        this.handleLocationContactChange = (field, value) => {
            this.props.onLocationContactChange(this.props.stop, field, value);
        };
        this.handleLocationNameSelect = (selectedLocation) => {
            this.props.onNameSelect(this.props.stop, selectedLocation);
        };
        this.handleLocationAddressSelect = (item) => {
            this.props.onAddressSelect(this.props.stop, item);
        };
        this.handleStartChange = (start) => {
            this.props.onStartChange(this.props.stop, start);
        };
        this.handleEndChange = (end) => {
            this.props.onEndChange(this.props.stop, end);
        };
        this.handleRemoveStop = () => {
            this.props.onRemoveStop(this.props.stop);
        };
        this.handleLoadDistributionSave = (newStops) => {
            const { stops, onStopFieldChange } = this.props;
            stops.forEach((stop, i) => {
                onStopFieldChange(stop, 'loads', newStops[i].loads);
            });
            this.hideLoadDistributionModal();
        };
        this.handleSaveReferenceNumbers = (reference_numbers) => {
            reference_numbers.forEach((refnum) => {
                refnum.stop_id = this.props.stop.id;
            });
            this.handleStopFieldChange('reference_numbers', reference_numbers);
            this.hideRefnumModal();
        };
        this.showStopAppointmentModal = () => {
            this.setState({ showStopAppointmentModal: true });
        };
        this.hideStopAppointmentModal = () => {
            this.setState({ showStopAppointmentModal: false });
        };
        this.showLoadDistributionModal = () => {
            this.setState({ showLoadDistributionModal: true });
        };
        this.hideLoadDistributionModal = () => {
            this.setState({ showLoadDistributionModal: false });
        };
        this.showRefnumModal = () => {
            this.setState({ showAddRefnumsModal: true });
        };
        this.hideRefnumModal = () => {
            this.setState({ showAddRefnumsModal: false });
        };
        const isIntermodal = isIntermodalShipmentType({
            shipment_type: props.shipment_type,
        });
        const { t } = this.props;
        const stop_types = (isIntermodal
            ? stopIntents
            : stopIntents.filter((i) => !/Empty/.test(i.text))).map((item) => {
            return {
                name: titleize(t(item.localizationSlug)),
                value: item.slug,
            };
        });
        this.state = {
            stop_types,
        };
    }
    renderAddRefnumsModal() {
        if (!this.state.showAddRefnumsModal) {
            return null;
        }
        return (React.createElement(EditReferenceNumbersModal, { show: this.state.showAddRefnumsModal, reference_numbers: this.props.stop.reference_numbers, onClose: this.hideRefnumModal, onSave: this.handleSaveReferenceNumbers, stop: this.props.stop, isStop: true, page: true }));
    }
    render() {
        const { stop, stops, loads, timezone, t } = this.props;
        return (React.createElement("div", { className: "mb-6 grid sm:grid-cols-12 sm:gap-x-4 sm:gap-y-6" },
            React.createElement("div", { className: "sm:col-span-1" }, this.props.children),
            React.createElement("div", { className: "sm:col-span-2" },
                React.createElement(DropdownButton, { title: stop.action || t('STOP_TYPE'), items: this.state.stop_types, onSelect: (item) => {
                        this.handleStopFieldChange('action', item.value);
                    } })),
            React.createElement("div", { className: "sm:col-span-5" },
                React.createElement(Location, { sequence: stop.sequence, location: stop.location[0], locations: this.props.locations, onLocationFieldChange: this.handleLocationFieldChange, onNameSelect: this.handleLocationNameSelect, onAddressSelect: this.handleLocationAddressSelect, onLocationContactChange: this.handleLocationContactChange, onRemoveLocation: this.props.onRemoveLocation })),
            React.createElement("div", { className: "sm:col-span-3 space-y-3" },
                React.createElement("div", { className: "flex items-center justify-start gap-2 px-2 w-max" },
                    React.createElement(Checkbox, { checked: (stop === null || stop === void 0 ? void 0 : stop.appointment_required) || false, className: `
                w-5 h-5 border rounded 
                cursor-pointer 
                border-gray-400
                data-[state=checked]:bg-green-600 
                data-[state=checked]:border-green-600
                transition-colors
              `, id: `appointment_required_${stop.sequence}`, defaultChecked: false, onCheckedChange: (value) => {
                            this.handleRequireAppointmentFieldChange('appointment_required', value);
                        } }),
                    React.createElement(Label, null, t('REQUIRES_APPOINTMENT'))),
                !(stop === null || stop === void 0 ? void 0 : stop.appointment_required) && (React.createElement("button", { className: "block", onClick: this.showStopAppointmentModal },
                    !stop.window_start && !stop.window_end && (React.createElement(IconTextDisplay, { className: "items-center", icon: React.createElement(CalendarIcon, { color: "" }) },
                        React.createElement("div", { className: "text-sm text-red-500" }, t('SET_APPOINTMENT')))),
                    React.createElement("div", { className: "space-y-2" },
                        stop.window_start && (React.createElement(IconTextDisplay, { color: "green", icon: React.createElement(CalendarIcon, null) },
                            React.createElement("dl", { className: "text-left" },
                                React.createElement("dt", { className: "mb-1 form-label" }, t('START')),
                                React.createElement("dd", { className: "block text-sm text-gray-900" }, formatDate(stop.window_start, timezone, t))))),
                        stop.window_end && (React.createElement(IconTextDisplay, { color: "red", icon: React.createElement(CalendarIcon, null) },
                            React.createElement("dl", { className: "text-left" },
                                React.createElement("dt", { className: "mb-1 form-label" }, t('END')),
                                React.createElement("dd", { className: "block text-sm text-gray-900" }, formatDate(stop.window_end, timezone, t)))))))),
                React.createElement("button", { className: "block", onClick: this.showLoadDistributionModal },
                    React.createElement(IconTextDisplay, { icon: React.createElement(TruckIcon, null) },
                        React.createElement("div", { className: "space-y-2" }, stop.loads &&
                            stop.loads.length &&
                            stop.loads.map((l, i) => {
                                return (React.createElement("dl", { className: "block text-sm text-left space-y-1", key: i },
                                    React.createElement("dd", null,
                                        getLoadQuantity(l, t),
                                        ", ",
                                        getLoadDimensions(l, t)),
                                    React.createElement("dd", null, getLoadWeight(l, t))));
                            })),
                        (!stop.loads || !stop.loads.length) && (React.createElement("div", { className: "text-sm text-red-500" }, t('NO_LOADS_DISTRIBUTED'))))),
                React.createElement("button", { className: "text-sm text-blue-500 hover:text-blue-600", onClick: this.showRefnumModal }, t('ADD_STOP_REFERENCE'))),
            SessionStore.hasMultiStopBookingRole() && (React.createElement("div", { className: "sm:col-span-1" },
                React.createElement(Tooltip, { content: t('REMOVE_STOP') },
                    React.createElement(DeleteButton, { className: "w-5 h-5", onClick: this.handleRemoveStop })))),
            this.state.showStopAppointmentModal && (React.createElement(StopAppointmentWindowModal, { show: this.state.showStopAppointmentModal, onClose: this.hideStopAppointmentModal, stop: stop, selected_timezone: timezone, onStartChange: this.handleStartChange, onEndChange: this.handleEndChange })),
            this.state.showLoadDistributionModal && (React.createElement(LoadDistributionModal, { show: this.state.showLoadDistributionModal, onClose: this.hideLoadDistributionModal, stops: stops, loads: loads, onSave: this.handleLoadDistributionSave })),
            this.renderAddRefnumsModal()));
    }
}
Stop.propTypes = {
    stop: PropTypes.object.isRequired,
    stops: PropTypes.array.isRequired,
    shipment_type: PropTypes.string.isRequired,
    locations: PropTypes.array,
    timezone: PropTypes.string,
    children: PropTypes.object, // drag handle
    onStopFieldChange: PropTypes.func.isRequired,
    onLocationFieldChange: PropTypes.func.isRequired,
    onNameSelect: PropTypes.func.isRequired,
    onAddressSelect: PropTypes.func.isRequired,
    onStartChange: PropTypes.func.isRequired,
    onEndChange: PropTypes.func.isRequired,
    onRemoveLocation: PropTypes.func.isRequired,
    onRemoveStop: PropTypes.func.isRequired,
};
export default withTranslation()(Stop);
